import React, { useRef, useEffect, useState } from 'react';

import Moment from 'moment';

import { useTheme } from 'styled-components';

import { IoIosNotifications } from 'react-icons/io';
import { BsFillTrashFill } from 'react-icons/bs';
import { AiFillCloseCircle } from 'react-icons/ai';

import { toast } from 'react-toastify';

import { useNotifications } from '~/hooks/notifications';

import { Container } from './styles';

import { NotificationsProps } from './interface';

import api from '~/services/api';

import AvisoType from '~/@types/aviso';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const alarmAudio = require('../../../assets/alarm.mp3');

const Notifications: React.FC<NotificationsProps> = () => {

  const { colors } = useTheme();

  const audioPlayer = useRef(null);

  const [notifications, setNotifications] = useState<AvisoType[]>([]);

  const { setTotal } = useNotifications();

  const fetchNotifications = async () => {
    try {
      const response = await api.get(`avisos-internos/nao-lidos`);

      const { data } = response;
      if (!data.error) {
        setNotifications(data);
        setTotal(data.length);
      }
    } catch (err) {}
  };

  const dismissNotification = async (id: string) => {
    try {
      const response = await api.delete(`avisos-internos?id=${id}`);

      const { data } = response;
      if (data && !data.error) {
        fetchNotifications();
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error(`${(e as Error).message}`);
    }
  };

  const dismissAll = () => {
    setNotifications([]);
  };

  useEffect(() => {
    const _interval = setInterval(() => {
      fetchNotifications();
    }, 60 * 1000);

    return () => {
      clearInterval(_interval);
    };
  });

  if (!notifications.length) {
    return null;
  }

  return (
    <Container>
      <audio ref={audioPlayer} src={alarmAudio} autoPlay />

      <header>
        <IoIosNotifications size={64} color={colors.IC1} />
        <div>
          <h1>Notificações!</h1>
          <h2>
            {notifications.length > 1
              ? `${notifications.length} notificações importantes.`
              : `Uma nova notificação.`}
          </h2>
        </div>
        <button onClick={() => dismissAll()}>
          <AiFillCloseCircle size={36} color={colors.IC1} />
        </button>
      </header>
      <div>
        <ul>
          {notifications.map(notification => (
            <li>
              <p>
                <span>{notification.mensagem}</span>
                <strong>{Moment(notification.ts).format('DD/mm/YYYY HH:mm')}</strong>
                <small>{Moment(notification.ts).fromNow()}</small>
              </p>
              <button onClick={() => dismissNotification(notification.idaviso)}>
                <BsFillTrashFill size={22} color={colors.IC1} />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
};

export default Notifications;
